<template>
  <el-form-item :prop="id">
    <div class="field__label_wrap">
      <label class="el-form-item__label" :for="id">{{label}}</label>
      <div v-if="$slots.accessory" class="el-form-item__accessory">
        <slot name="accessory" />
      </div>
    </div>
    <div v-if="description" class="field__description">{{description}}</div>
    <el-input
      :id="id"
      v-bind="$attrs"
      v-on:input="$emit('input', $event)"
    />
  </el-form-item>
</template>

<script>
  export default {
    name: 'InputField',
    inheritAttrs: false,
    props: {
      id: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        required: true,
      },
      description: String,
    },
  }
</script>

<style lang="scss" scoped>
  .field__label_wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .field__description {
    font-style: italic;
    font-size: 14px;
    margin-bottom: 6px;
  }

  :deep(.el-input) {
    font-size: 16px;
  }

</style>
